/**
 * The last pass over a report name or label: any `{Token}` still in it after the facility's own
 * words were filled in gets the desktop's default word, so a card never reads "By {SetName}"
 * (UI audit, 2026-10-25: the token showed when the facility's setting was empty or had not
 * loaded). A token with no default is spelled out from its name ("{ProblemGoalApproach}" ->
 * "Problem Goal Approach") rather than shown with its braces.
 */
const TOKEN_DEFAULTS: Record<string, string> = {
  setname: 'Set',
  setname_plural: 'Sets',
  set: 'Set',
  room: 'Room',
  resident: 'Resident',
  resident_plural: 'Residents',
  residentplural: 'Residents',
  facility: 'Facility',
  facility_plural: 'Facilities',
  breakfast: 'Breakfast',
  lunch: 'Lunch',
  dinner: 'Dinner',
  breakfast_first: 'B',
  lunch_first: 'L',
  dinner_first: 'D',
  nourisheam: 'EAM',
  nourisham: 'AM',
  nourishpm: 'PM',
  nourishhs: 'HS',
  ehr_title: 'EHR',
  ehr: 'EHR',
  credits: 'Credits',
  specialdevice: 'Special Device',
  prescriber: 'Prescriber',
  floororunit: 'Floor',
  mealpatternshortdescription: 'Meal Pattern',
  adjustmentsshortdescription: 'Adjustments',
  problemgoalapproach: 'Problem/Goal/Approach',
};

/** "ProblemGoalApproach" / "Some_Field" -> "Problem Goal Approach" / "Some Field". */
function spellOut(token: string): string {
  return token
    .replace(/_/g, ' ')
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .trim();
}

export function fillUnresolvedTokens(text: string): string;
export function fillUnresolvedTokens(text: string | null | undefined): string | null | undefined;
export function fillUnresolvedTokens(text: string | null | undefined): string | null | undefined {
  if (!text || !text.includes('{')) return text;
  return text.replace(/\{(\w+)\}/g, (_m, token: string) => TOKEN_DEFAULTS[token.toLowerCase()] ?? spellOut(token));
}
